import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import { getWeekdayNames } from './calendar-utils/intl.esm.js';
import styles from '../uitk-calendar.css';

// Modules
var getClassNameList = classNames.bind(styles);
var WeekdayNames = function (_a) {
  var dayNameLength = _a.dayNameLength,
    locale = _a.locale;
  var baseClass = 'uitk-weekday';
  var weekDayNameClasses = React.useMemo(function () {
    return getClassNameList("".concat(baseClass, "-names"));
  }, []);
  var weekDayClasses = React.useMemo(function () {
    return getClassNameList("".concat(baseClass, "-title"));
  }, []);
  var l10n = useLocalization();
  var longWeekdayNames = React.useMemo(function () {
    return getWeekdayNames(l10n, locale, 'long');
  }, [l10n, locale]);
  var weekdayNames = React.useMemo(function () {
    return dayNameLength === 'long' ? longWeekdayNames : getWeekdayNames(l10n, locale, dayNameLength);
  }, [dayNameLength, l10n, locale, longWeekdayNames]);
  return React.createElement("tr", {
    className: weekDayNameClasses
  }, weekdayNames.map(function (weekdayName, i) {
    return React.createElement("th", {
      scope: "col",
      className: weekDayClasses,
      key: "weekday-".concat(i)
    }, React.createElement("span", null, weekdayName), React.createElement("span", {
      className: "is-visually-hidden"
    }, longWeekdayNames[i]));
  }));
};
WeekdayNames.displayName = 'WeekdayNames';
export { WeekdayNames as default };